import React from 'react';
import { SectionWrapper } from '../components/ui/SectionWrapper';
import { HowEvaluationWorksSection } from '../components/sections/HowEvaluationWorksSection';
import { TransparencySection } from '../components/sections/TransparencySection';
export function MethodologyPage() {
  return <div className="bg-white min-h-screen" data-id="element-418">
      <div className="py-20 px-6 bg-slate-900 text-white text-center" data-id="element-419">
        <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-420">Our Methodology</h1>
        <p className="text-xl text-slate-300 max-w-2xl mx-auto" data-id="element-421">
          Rigorous, standardized, and editorially independent. How we evaluate
          the door-to-door industry.
        </p>
      </div>

      <HowEvaluationWorksSection data-id="element-422" />
      <TransparencySection data-id="element-423" />

      <SectionWrapper data-id="element-424">
        <div className="max-w-3xl mx-auto prose prose-slate" data-id="element-425">
          <h2 data-id="element-426">The Evaluation Framework</h2>
          <p data-id="element-427">
            Every guide we publish follows a strict 4-step process to ensure
            neutrality and usefulness. We do not accept payment for higher
            rankings, and we do not allow companies to edit our reviews.
          </p>
          <h3 data-id="element-428">1. Data Collection</h3>
          <p data-id="element-429">
            We gather data from public filings, user interviews, mystery
            shopping, and direct software testing.
          </p>
          <h3 data-id="element-430">2. Verification</h3>
          <p data-id="element-431">
            Claims are cross-referenced against verified user reviews and
            contract analysis.
          </p>
          <h3 data-id="element-432">3. Analysis</h3>
          <p data-id="element-433">
            We apply our standardized scoring rubric to assess features,
            pricing, and risk.
          </p>
          <h3 data-id="element-434">4. Peer Review</h3>
          <p data-id="element-435">
            Before publication, every guide is reviewed by at least two industry
            experts for accuracy.
          </p>
        </div>
      </SectionWrapper>
    </div>;
}